import { Module, ActionContext } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  PAGE: '/dh-datamaint/questionBaseType/admin/list',
  LIST: '/dh-datamaint/questionBaseType/list'
};

class BasicTypeModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getPage(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.PAGE, { params: payload.data });
    },

    async getBasicTypeList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.LIST, { params: payload.data });
    }
  };
}

export const basicTypeModule = new BasicTypeModule();
